import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path
      d="M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0zM7.216 13.553l-3.63-3.629L4.859 8.65l2.357 2.357 5.925-5.925 1.272 1.273-7.197 7.198z"
      fill="#fff"
    />
  </svg>
);

export default SvgComponent;
